__turbopack_context__.v({
  "clock": "Clock-module__-qn03G__clock",
  "hours": "Clock-module__-qn03G__hours",
  "minutes": "Clock-module__-qn03G__minutes",
  "spin": "Clock-module__-qn03G__spin",
  "textLoading": "Clock-module__-qn03G__textLoading",
});
